import axios from 'axios'
import { apiDomain } from '../../store/constants'

const rental = {
    getUserInfo(data) {
        return axios({
            url: apiDomain + '/api/get-user-info',
            method: 'POST',
            data
        }).catch(err => {
            console.log('Catch error ' + err)
        })
    }
}

export default rental